import React, { useState , useEffect} from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import NavBar from './navBar';
import MenuPanel from './menuPanel';
import { useNavigate } from 'react-router-dom';

const LimitedEditionPage = () => {
  
  const navigate = useNavigate();
  const handleShopRedirect = () => {

    const direction="PageProducts";
    navigate(`/${direction.toLowerCase()}`);
  };

  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);

  return (
    <View style={styles.container}>
    {/* NavBar with Menu Button */}
    <NavBar toggleMenu={toggleMenu} />
    <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />
    <ScrollView style={styles.contentContainer}>
      {/* Introduzione Edizioni Limitate */}
      <View style={styles.introductionSection}>
        <Text style={styles.title}>Scopri le Nostre Edizioni Limitate</Text>
        <Text style={styles.description}>
          Durante l'anno, rilasciamo edizioni limitate con design esclusivi e un numero limitato di pezzi. Ogni prodotto in edizione limitata è pensato per celebrare la nostra community e offrire qualcosa di veramente speciale.
        </Text>
      </View>

      {/* Banner Principale */}
      <View style={styles.overlayBanner}>
        <Text style={styles.overlayText}>Prossima Edizione Limitata Presto Disponibile</Text>
      </View>
    
      {/* Sezione Dettagli Premium */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Esclusività per i Membri Premium</Text>
        <View style={styles.card}>
          <Text style={styles.cardTitle}>I Membri Premium sono coloro che hanno già effettuato un acquisto.</Text>
        </View>
        <View style={styles.card}>
          <Text style={styles.cardTitle}>Accesso Prioritario</Text>
          <Text style={styles.cardText}>
            Solo i Membri Premium possono acquistare le edizioni limitate SUBITO al lancio. Ogni membro ha diritto all’acquisto di un singolo pezzo per collezione, garantendo un'esperienza esclusiva.
          </Text>
          <Text style={styles.cardTitle}>Come Funziona</Text>
          <Text style={styles.cardText}>
            - Solo i Membri Premium avranno a disposizione un codice univoco (che riceveranno via mail) che gli permetterà di acquistare edizioni limitate al momento del lancio.
          </Text>
          <Text style={styles.cardText}>
            - Con un codice è possibile acquistare solo un capo Edizione Limitata.
          </Text>
          <Text style={styles.cardText}>
            - Ad ogni acquisto di uno prodotto verrà associato un solo codice (comprando 5 prodotti si riceveranno 5 codici).
          </Text>
        </View>
      </View>

      {/* Informazioni sui Rilasci */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Informazioni sui Rilasci</Text>
        <View style={styles.card}>
          <Text style={styles.cardTitle}>Nuove Collezioni</Text>
          <Text style={styles.cardText}>
            Ogni edizione limitata verrà annunciata con un design unico e un numero specifico di pezzi, rivelati solo alla data di lancio.
          </Text>
        </View>
        <View style={styles.card}>
          <Text style={styles.cardTitle}>Disponibilità per Tutti</Text>
          <Text style={styles.cardText}>
            La vendita sarà aperta al pubblico una settimana dopo il lancio, soggetta a disponibilità. I Membri Premium hanno quindi un vantaggio unico!
          </Text>
        </View>
      </View>

      {/* Bottone per Diventare Membro Premium */}
      <TouchableOpacity onPress={handleShopRedirect} style={styles.button}>
        <Text style={styles.buttonText}>Diventa Membro Premium</Text>
      </TouchableOpacity>
    </ScrollView>

    
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer:{
    flex: 1,
    padding: 20,
    marginTop: 60,
    padding:10,
    backgroundColor: '#FFFFFF',
  },
  overlayBanner: {
    width: '100%',
    height: 250,
    backgroundColor: 'linear-gradient(90deg, rgba(218, 165, 32, 0.85), rgba(255, 140, 0, 0.85))',
    padding: 20,
    borderRadius: 15,
    marginBottom: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlayText: {
    fontSize: 12,
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
  },
  introductionSection: {
    backgroundColor: '#fff',
    padding: 30,
    borderRadius: 15,
    marginBottom: 20,
    alignItems: 'center',
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
  },
  title: {
    fontSize: 14,
    fontWeight: '700',
    color: '#333',
    marginBottom: 15,
    textAlign: 'center',
  },
  description: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
    paddingHorizontal: 25,
  },
  section: {
    backgroundColor: '#fff',
    borderRadius: 15,
    padding: 25,
    marginBottom: 25,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.12,
    shadowRadius: 6,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: '#444',
    marginBottom: 10,
    textAlign: 'left',
  },
  card: {
    backgroundColor: '#f9f9f9',
    borderRadius: 12,
    padding: 20,
    marginVertical: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 5,
  },
  cardTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#333',
    marginBottom: 10,
  },
  cardText: {
    fontSize: 12,
    color: '#555',
    lineHeight: 22,
  },
  button: {
    marginTop: 30,
    backgroundColor: '#333',
    paddingVertical: 18,
    paddingHorizontal: 30,
    borderRadius: 10,
    width: '80%',
    alignSelf: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
  },
  buttonText: {
    fontSize: 12,
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
  },
});

export default LimitedEditionPage;
